/**
 * List of all the schema types we use in Sanity, as constants.
 * This allows us to refer to them by their constant symbol, rather than a magic string, in both
 * the Sanity Studio app, and the web app.
 */

// !!!!!!                         !!!!!!!!                              !!!!!! //
// DO NOT CHANGE THE VALUES OF THESE CONSTANTS WITHOUT CAREFUL CONSIDERATION.  //
//     CHANGING THE VALUES WILL CAUSE CONTENT TO DISAPPEAR FROM THE CMS        //
// !!!!!!                         !!!!!!!!                              !!!!!! //
export enum DOCUMENT {
  PAGES = 'pages',
  LEGAL_PAGES = 'legalPages',
  CAREER_PAGES = 'careerPages',
  ABOUT_FOOD_WASTE_PAGES = 'aboutFoodWaste.pages',
  ABOUT_FOOD_WASTE_BLOG = 'aboutFoodWaste.blog',
  ABOUT_FOOD_WASTE_BLOG_CATEGORIES = 'aboutFoodWaste.blog.categories',
  ABOUT_FOOD_WASTE_RESOURCES = 'aboutFoodWaste.resources',
  ABOUT_FOOD_WASTE_RESOURCES_CATEGORIES = 'aboutFoodWaste.resources.categories',
  ABOUT_US_PAGES = 'aboutUs.pages',
  BUSINESS_SOLUTIONS_SOLUTIONS = 'businessSolutions.solution',
  BUSINESS_SOLUTIONS_MARKETPLACES = 'businessSolutions.marketplaces',
  MARKETPLACE_PAGES = 'marketplace.pages',
  PARCELS_PAGES = 'parcels.pages',
  PLATFORM_PAGES = 'platform.pages',
  DATE_LABELLING_PAGES = 'dateLabelling.pages',
  DONATIONS_PAGES = 'donations.pages',
  MARKETPLACES_VENDOR_TYPE = 'marketplaces.vendorType',
  REDIRECTS = 'redirects',
  STATISTICS = 'statistics',
  NAVIGATION_HEADERS = 'navigation.headers',
  NAVIGATION_FOOTERS = 'navigation.footers',
  ANNOUNCEMENTS = 'announcements',
  MEDIA_TAG = 'media.tag',
  FAQ = 'faq',
  PEOPLE = 'people',
  PARTNER_LOGO = 'partner.logo',
  COMPANIES = 'companies',
  AUTHORS = 'authors',
  FRAGMENT_FORMS = 'fragments.forms',
  FRAGMENT_SALESFORCE_FORMS = 'fragments.salesforceForms',
  FRAGMENT_SUPPORT_PATH = 'fragments.supportPath',
  FRAGMENT_SIGNATURE_GENERATOR = 'fragments.signatureGenerator',
  FRAGMENT_REPORTS = 'fragments.reports',
  FRAGMENT_BRAND_PROFILE_DEFAULTS = 'fragments.brandProfileDefaults',
  PRESS_RELEASES = 'press.releases',
  FRAGMENT_SURPRISE_BAG = 'fragments.surpriseBag',
  PRESS_MEDIA_ASSETS = 'press.mediaAssets',
  PRESS_MEDIA_ASSETS_CATEGORIES = 'press.mediaAssets.categories',
  PRESS_NEWS_COVERAGE = 'press.newsCoverage',
  DEFAULT_BLOCKS = 'defaultBlocks',
  INITIATIVE_PAGES = 'initiativePages',
  INITIATIVE_B2B_PAGES = 'initiativeB2BPages',
  ACQUISITION_B2B_PAGES = 'acquisitionB2BPages',
  ACQUISITION_B2C_PAGES = 'acquisitionB2CPages',
  CONFIG_REUSABLE_BLOCKS = 'config.reusableBlocks',
  AUDIENCE = 'audience',
  SURPRISE_BAG_HOME = 'surpriseBagHome',
  SURPRISE_BAG_PAGES = 'surpriseBagPages',
  BRAND_PROFILE = 'brandProfile',
  BUSINESS_HOMEPAGE = 'businessHomepage',
}

export enum OBJECT {
  SIMPLE_PORTABLE_BLOCKS = 'simplePortableBlocks',
  PORTABLE_BLOCKS = 'portableBlocks',
  NAVIGATION_LINK_INTERNAL = 'link.internal',
  NAVIGATION_LINK_EXTERNAL = 'link.external',
  NAVIGATION_LINK_SSU = 'link.ssu',
  LINK_FUNCTIONAL = 'link.functional',
  NAVIGATION_DROPDOWN_CTA = 'dropdown.cta',
  NAVIGATION_DROPDOWN_CARDS = 'dropdown.cards',
  NAVIGATION_DROPDOWN_ICONS = 'dropdown.icons',
  NAVIGATION_LINK_CARD = 'link.card',
  NAVIGATION_LINK_ICON = 'link.icon',
  NAVIGATION_LINK_SOCIAL = 'link.social',
  NAVIGATION_LINK = 'link',
  LANGUAGE = 'language.field',
  IMAGE_WITH_ALT = 'imageWithAlt',
  BUTTON = 'button',
  APPSTORE_LINK = 'appstoreLink',
  FORM_FIELD = 'formFields',
  FORM_NOTIFICATION_EMAIL = 'formNotification.email',
  FORM_NOTIFICATION_STORE_LEAD = 'formNotification.storeLead',
  FORM_NOTIFICATION_REPORT = 'formNotification.report',
  FORM_NOTIFICATION_SUPPORT = 'formNotification.support',

  MODULAR_OUTER_BLOCKS = 'modularContentBlocks.outer',
  MODULAR_INNER_BLOCKS = 'modularContentBlocks.inner',

  MODULAR_OUTER_BLOCK_SECTION = 'modularContentBlocks.outer.section',
  MODULAR_OUTER_BLOCK_HERO = 'modularContentBlocks.outer.hero',
  MODULAR_OUTER_BLOCK_SUB_HERO = 'modularContentBlocks.outer.subHero',
  MODULAR_OUTER_BLOCK_CAROUSEL_SECTION = 'modularContentBlocks.outer.carouselSection',
  MODULAR_OUTER_SOLUTION_FINDER = 'modularContentBlocks.outer.solutionFinder',
  MODULAR_OUTER_SUPPORT_SECTION = 'modularContentBlocks.outer.supportSection',
  MODULAR_OUTER_BLOCK_TICKER_SECTION = 'modularContentBlocks.outer.tickerSection',
  MODULAR_OUTER_BLOCK_STEPS_SECTION = 'modularContentBlocks.outer.stepsSection',
  MODULAR_OUTER_BLOCK_BAG = 'modularContentBlocks.outer.bag',
  MODULAR_OUTER_BLOCK_REFERRAL = 'modularContentBlocks.outer.referral',
  MODULAR_OUTER_BLOCK_CTA = 'modularContentBlocks.outer.cta',
  MODULAR_OUTER_BLOCK_CAREERS = 'modularContentBlocks.outer.careers',
  MODULAR_OUTER_IMAGE_VIDEO = 'modularContentBlocks.outer.imageVideo',
  MODULAR_OUTER_BLOCK_SIGNATURE_GENERATOR = 'modularContentBlocks.outer.signatureGenerator',
  MODULAR_OUTER_BLOCK_COOKIE_LIST = 'modularContentBlocks.outer.cookieList',
  MODULAR_OUTER_BLOCK_SURPRISE_BAG_FINDER = 'modularContentBlocks.outer.surpriseBagFinder',
  MODULAR_OUTER_BLOCK_LOCATION_FINDER = 'modularContentBlocks.outer.locationFinder',
  MODULAR_OUTER_BLOCK_PRIVACY_CONTROLS = 'modularContentBlocks.outer.privacyControls',

  MODULAR_OUTER_BLOCK_SURPRISE_BAG = 'modularContentBlocks.inner.surpriseBag',
  MODULAR_INNER_BLOCK_TITLE = 'modularContentBlocks.inner.title',
  MODULAR_INNER_BLOCK_RAW_HTML = 'modularContentBlocks.inner.rawHtml',
  MODULAR_INNER_BLOCK_BASE_TEXT = 'modularContentBlocks.inner.baseText',
  MODULAR_INNER_BLOCK_BASE_BUTTON_GROUP = 'modularContentBlocks.inner.buttonGroup',
  MODULAR_INNER_BLOCK_TILES = 'modularContentBlocks.inner.tiles',
  MODULAR_INNER_BLOCK_NUDGE = 'modularContentBlocks.inner.nudge',
  MODULAR_INNER_BLOCK_FAQ = 'modularContentBlocks.inner.faq',
  MODULAR_INNER_BLOCK_STATISTICS = 'modularContentBlocks.inner.statistics',
  MODULAR_INNER_BLOCK_PEOPLE = 'modularContentBlocks.inner.people',
  MODULAR_INNER_BLOCK_TICKER = 'modularContentBlocks.inner.ticker',
  MODULAR_INNER_BLOCK_CALLOUT = 'modularContentBlocks.inner.callout',
  MODULAR_INNER_BLOCK_FORMS = 'modularContentBlocks.inner.forms',
  MODULAR_INNER_BLOCK_SALESFORCE_FORMS = 'modularContentBlocks.inner.salesforceForms',
  MODULAR_INNER_BLOCK_VIDEO = 'modularContentBlocks.inner.video',
  MODULAR_INNER_BLOCK_IMAGE = 'modularContentBlocks.inner.image',
  MODULAR_INNER_BLOCK_PROFILE_PICTURE = 'modularContentBlocks.inner.profilePicture',
  MODULAR_INNER_BLOCK_PARTNER_LOGO = 'modularContentBlocks.inner.partnerLogo',
  MODULAR_INNER_BLOCK_LISTING = 'modularContentBlocks.inner.listing',
  MODULAR_INNER_BLOCK_SOLUTION_TILES = 'modularContentBlocks.inner.solutionTiles',
  MODULAR_INNER_BLOCK_COUNTER_HERO = 'modularContentBlocks.inner.campaignCounter',
  MODULAR_INNER_BLOCK_SIMPLE_COUNTER = 'modularContentBlocks.inner.simpleCounter',
}

export enum SINGLETON {
  THEME = 'theme',
  CONFIG_SEO = 'config.seo',
  CONFIG_APPSTORES = 'config.appstores',
  CONFIG_SOCIAL = 'config.social',
  CONFIG_PLACEHOLDER_IMAGES = 'config.placeholderImages',

  RECYCLING_BIN = 'deletedDocs.bin', // Private documents have a dot in the document _id. Sanity prevents these from being read unless you are authenticated.
}
